import React, { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import BannerSingle from '../../../BannerSingle';
import PageDescriptionPlano from '../../../PageDescription/Planos/index';
import Lgpd from '../../../Lgpd';
import PatrimonioPlano from '../../../Numeros/Planos';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
// import { data } from 'jquery';

class DescricaoPage extends Component {
	render() {		

		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-a"} page={'plano-a'} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionPlano certificado={"/DOCS/Publicacoes/Certificados/Plano%20A/Certificado%20do%20Participante%20-%20Plano%20B.pdf"} page={'plano-a'} /></ErrorBoundary>

					{/* Content page */}
					<ErrorBoundary><PatrimonioPlano url={"/ObterDescricaoPlanoA"} urlTable={"/ObterDescricaoPlanoA"}  page={'plano-a'}/></ErrorBoundary>
					{/* <ErrorBoundary><PatrimonioPlano url={"/ObterDescricaoPlanoA"} urlTable={"/ObterDescricaoPlanoA"} htmlPart={
						<div className="col-md-10">							

							<hr />
							<h3> Critérios para requerer benefício </h3>
							<ul>
								<li>
									Estar desligado da patrocinadora;
								</li>
								<li>
									Ter contribuído para a Previdência Social durante no mínimo 25 anos, se for mulher, ou 30 anos, se for homem ou estar aposentado pelo INSS.
								</li>
							</ul>

							<br />
							<br />

							<h3>Modalidades de benefícios</h3>
							<p>
								Complementação Proporcional de Aposentadoria – CPA:  benefício vitalício concedido ao participante que preenche os requisitos relacionados acima. O benefício é apurado com base na média das 36 remunerações mensais do Participante na Patrocinadora, imediatamente anteriores à data de início dos efeitos financeiros do plano, sobre as quais incidiu contribuição para o antigo Plano BD da Forluz.
								<br /> <br />
								Renda Continuada por Morte - RCM: benefício concedido aos beneficiários do participante em gozo de CPA que falece. Corresponde ao percentual de 75% do benefício percebido no momento do falecimento,  dividido em partes iguais pelos  beneficiários inscritos.
							</p>
						</div>
					} /></ErrorBoundary> */}
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default DescricaoPage;